import { API, setAuthToken } from '../../../config/API.js';
import { GET_ANAK_PERUSAHAAN, SET_LOADING_ANAK_PERUSAHAAN, SET_PAGINATION_ANAK_PERUSAHAAN } from '../constant.js';

export const getAnakPerusahaan = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_ANAK_PERUSAHAAN,
      payload: true,
    });
    API.get(`admin/subsidiary?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_ANAK_PERUSAHAAN,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_ANAK_PERUSAHAAN,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_ANAK_PERUSAHAAN,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_ANAK_PERUSAHAAN,
          payload: 0,
        });
      });
  };
};

export const addAnakPerusahaan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/subsidiary/add", params);
};

export const getDetailAnakPerusahaan = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/subsidiary/" + id);
};

export const updAnakPerusahaan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/subsidiary/edit", params);
};

export const delAnakPerusahaan = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/subsidiary/delete/" + code);
};
